import { render, staticRenderFns } from "./targetStatisticsDetail.vue?vue&type=template&id=318af6ba&scoped=true&"
import script from "./targetStatisticsDetail.vue?vue&type=script&lang=js&"
export * from "./targetStatisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./targetStatisticsDetail.vue?vue&type=style&index=0&id=318af6ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318af6ba",
  null
  
)

export default component.exports